import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import {ordersData} from './create-workspace/http-post-request-object-classes/ordersData';
import { interval } from 'rxjs/observable/interval';
import {environment} from '../environments/environment'
import {Observable} from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import {RequestOptions, Request, RequestMethod} from '@angular/http';
import {HttpClient} from '@angular/common/http';
import {HttpRequest} from '@angular/common/http';
import { map, filter, catchError, mergeMap, tap, last } from 'rxjs/operators';
import {HttpEvent} from '@angular/common/http';
import {HttpEventType} from '@angular/common/http'


@Injectable()
export class WorkspaceService {

  constructor(public http:HttpClient) { }
  url = environment.url
  order(model){
    return this.http.post(this.url+'/order',model)
  };
  login(model){
    return this.http.post(this.url+'/login',model)
  };
  delete(model){
    return this.http.post(this.url+'/terminate',model)
  };
  requestSoftwareVersion(model){
    return this.http.post(this.url+'/configs',model)
  }
  register(model){
    return this.http.post(this.url+'/signup',model)
  }
  status(model){
    return this.http.post(this.url+'/status',model)
  }
  terminate(model){
    return this.http.post(this.url+'/terminate',model)
  }
  extend(model){
    return this.http.post(this.url+'/extend',model)
  }
  upload(model) {

    // let headers =  {headers: new  HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded'})};
    return this.http.post(this.url+'/upload',model)



  }
  uploadSecondTime(model, url) {
    const req = new HttpRequest('PUT', url, model, {
      reportProgress: true
    });
    return this.http.request(req).pipe(
      map(event => this.getEventMessage(event, model)),
      tap(message => this.showProgress(message)),
      // last(), // return last (completed) message to caller
      // catchError(this.handleError(file))
    );
    // const headers = new HttpHeaders()
    // .set("Content-Type", "text/html");
    // return this.http.put(url,model,{observe:'response'})

  }
  forceDownload(blob, filename) {
    let a = document.createElement('a');
    a.download = `${filename}`;
    a.href = blob;
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
  downloadResource(url, filename, self) {
    // fetch(url, {
    //   headers: new Headers({
    //     'Origin': location.origin
    //   }) as any,
    //   mode: 'cors'
    // })
    // .then(response => response.blob())
    // .then(blob => {
    //   let blobUrl = window.URL.createObjectURL(blob);
    //   self.forceDownload(blobUrl, filename);
    // })
    this.http.get(url,{responseType: 'blob' as 'json'}).subscribe(data => {
      let responseFile = data as any;
      let blob = new Blob([responseFile]);
      let blobUrl = window.URL.createObjectURL(blob);
      this.forceDownload(blobUrl, filename);
      let thisFileExtension = filename.toString().split('.')[1];
    })
  }
  downloadFile(url, fileName) {
    let self = this;
    self.downloadResource(url, fileName, self);
  }
  showProgress(message) {
    return message
  }
  private getEventMessage(event: HttpEvent<any>, file: File) {
    switch (event.type) {
      case HttpEventType.Sent:
        return `Uploading file "${file.name}" of size ${file.size}.`;

      case HttpEventType.UploadProgress:
        // Compute and show the % done:
        const percentDone = Math.round(100 * event.loaded / event.total);
        // return `File "${file.name}" is ${percentDone}% uploaded.`;
        return [file.name, percentDone];

      case HttpEventType.Response:
        return `File "${file.name}" was completely uploaded!`;

      default:
        return `File "${file.name}" surprising upload event: ${event.type}.`;
    }
  }

  getListOfFilesFromS3(model){
    return this.http.post(this.url+'/list',model);
  }
  getDownloadFileUrl(model) {
    return this.http.post(this.url+'/download',model);
  }
  reboot(model) {
    return this.http.post(this.url+'/reboot',model);
  }
  forgotPasswordSendMail(model) {
    return this.http.post(this.url + '/reset_password',model);
  }
  connectVM(model) {
    return this.http.post(this.url + '/token',model);
  }
  source = interval(60000);
  // source = interval(5000); // only for testing to get result in 1 sec not 5 minutes
  warningCheck = interval(180000);
  routeMemory = '';
  loginData = new ordersData('','','','','');
  loginAuthorized = false;
  theme = "light";
}



// WEBPACK FOOTER //
// ./src/app/workspace.service.ts